<div class="leftPadding">
  <form [formGroup]="chronicAcuteForm">
    <prism-ui-form-field-select
      [isValid]="formControlUtilitiesService.isControlValid(chronicAcuteForm, controlName)"
      [formFieldItemsCount]="chronicAcuteRadioButtonOptions.length"
      key-id="genderRadio"
      orientation="horizontal"
      >
      <span slot="error">{{ requiredElement?.error }}</span>

    </prism-ui-form-field-select>

    <div class="dualRadioHorizontalMhs">
      @for (opt of chronicAcuteRadioButtonOptions; track opt; let index = $index) {
        <div id="{{controlName}}" formArrayName="{{controlName}}" slot="input-{{ index + 1 }}">
          <prism-ui-radio-button
            labelText="{{opt.label}}"
            [keyId]="controlName + opt.name"
            ngDefaultControl
            [name]="controlName + opt.name"
            formControlName="{{ controlName + index }}"
            [checked]="chronicAcuteForm.get(controlName).value === opt.name"
            (prismUiRadioButtonOnChange)="logRadioChangeEvent(controlName, opt.name)"
            >
          </prism-ui-radio-button>
        </div>
      }
    </div>

    <div class="topPadding">
      @if (chronicAcuteForm.contains(controlName) && controlName !== null) {
        @if (chronicAcuteForm.get(controlName).value === 'acute') {
          <app-additional-details [mhsControl]="levelTwoQuestion" [parentForm]="parentForm"></app-additional-details>
        }
      }
    </div>
  </form>
</div>